import { useState } from "react";
import { useParams } from "react-router-dom";
import { useEvents } from "@/hooks/useEvents";
import { LeagueGroups } from "@/components/LeagueGroups";
import { SportIcon } from "@/components/SportIcon";

const TABS = [["pre", "Upcoming"], ["in", "Live"], ["post", "Results"]];

export default function SportPage() {
  const { key } = useParams();
  const [state, setState] = useState("pre");
  const [shown, setShown] = useState(40);
  const { data } = useEvents({ sport: key, state }, state === "in" ? 20000 : 60000);
  const name = data?.[0]?.sport_name || key.replace("-", " ");
  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#10B981]/10 text-[#10B981]">
          <SportIcon sport={key} className="h-6 w-6" />
        </span>
        <h1 data-testid="sport-page-title" className="font-display text-4xl font-black uppercase tracking-tight sm:text-5xl">
          {name}
        </h1>
      </div>
      <div className="flex gap-1 border-b border-[#1E293B]">
        {TABS.map(([v, l]) => (
          <button
            key={v}
            data-testid={`sport-tab-${v}`}
            onClick={() => { setState(v); setShown(40); }}
            className={`-mb-px border-b-2 px-4 py-2 font-display text-sm font-bold uppercase tracking-wide transition-colors ${
              state === v ? "border-[#10B981] text-[#10B981]" : "border-transparent text-slate-400 hover:text-white"
            }`}
          >
            {l}
          </button>
        ))}
      </div>
      <LeagueGroups
        events={data && data.slice(0, shown)}
        showOdds={state !== "post"}
        empty={state === "in" ? "Nothing live in this sport right now — check upcoming matches." : "No matches in this window."}
      />
      {data && data.length > shown && (
        <button data-testid="sport-show-more" onClick={() => setShown((s) => s + 40)}
          className="w-full rounded-lg border border-[#1E293B] bg-[#121824] py-3 font-display font-bold uppercase text-slate-300 hover:border-[#10B981] hover:text-white">
          Show more ({data.length - shown} matches)
        </button>
      )}
    </div>
  );
}
